<template>
  <div class="tiny-label">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.tiny-label {
  display: inline;
  font-size: 20px;
  border-radius: 5px;
  padding: 2px 5px;
  color: white;
  &.red {
    background-color: #801512;
  }
  &.green {
    background-color: #008000;
  }
}
@include media(mobile) {
  .tiny-label {
    font-size: 16px;
  }
}
</style>